// Dreh-Gizmo-Mathematik: Winkel in der Ring-Ebene je Rotationsachse.
// Die Basen sind rechtshändig gewählt (u × w = Achse), damit eine positive
// Euler-Rotation den Punkt in positive Winkelrichtung bewegt — das Teil
// folgt so exakt dem Finger auf dem Ring. Engine-frei.

export const ROTATION_AXES = ["x", "y", "z"]

// v: Vektor vom Teilmittelpunkt zum Zeigerpunkt in der Ring-Ebene
export function planeAngle(axis, v) {
  switch (axis) {
    case "x": return Math.atan2(v.z, v.y) // u=y, w=z (y×z=x)
    case "y": return Math.atan2(v.x, v.z) // u=z, w=x (z×x=y)
    default: return Math.atan2(v.y, v.x)  // u=x, w=y (x×y=z)
  }
}

export function rotationDeltaDeg(axis, fromVector, toVector) {
  return ((planeAngle(axis, toVector) - planeAngle(axis, fromVector)) * 180) / Math.PI
}
